export default {
  methods: {

    set_LocalValues(){

      // DataItems
      this.rawData = JSON.parse(JSON.stringify(this.DataItems))
      this.title = JSON.parse(JSON.stringify(this.Queries.SQL1[0]))

      // Json
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.header   = json.header
      this.items    = json.items
      this.sundries = json.sundries
      this.keys     = json.keys
      this.filters  = json.filters

      this.gmx_tableCoordinates('x', this.header.group, 0)
      this.header.width = this.header.group[this.header.group.length-1].ex
      
    },

  }
}